module.exports = __webpack_public_path__ + "img/save.9dda377d.svg";